window.theme = window.theme || {};

theme.Collection = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)',
    mediaQuerySidebar: '(min-width: 1200px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Collection(container) {
    this.filterSelect = container.querySelector(selectors.filterSelection);
    this.sortSelect = container.querySelector(selectors.sortSelection);

    this.selects = document.querySelectorAll(selectors.selectInput);

    if (this.sortSelect) {
      this.defaultSort = this._getDefaultSortValue();
    }

    if (this.selects.length) {
      this.selects.forEach(function(select) {
        select.classList.remove('hidden');
      });
    }

    this.initBreakpoints = this._initBreakpoints.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);

    // Separate media query for sidebar (1200px breakpoint)
    this.sidebarMql = window.matchMedia(settings.mediaQuerySidebar);

    if (this.filterSelect) {
      this.filterSelect.addEventListener(
        'change',
        this._onFilterChange.bind(this)
      );
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
    }

    theme.Helpers.promiseStylesheet().then(
      function() {
        this._initBreakpoints();
      }.bind(this)
    );
    this._initParams();

    // Sidebar + toggle buttons (scoped to this container only)
    this.sidebar = container.querySelector('.collection-sidebar');
    this.toggleBtns = container.querySelectorAll('.open_mobile_sidebar, .filters-toolbar .open_mobile_sidebar');

    this._setSidebarOpen = function (open) {
      if (!this.sidebar) return;

      // Mobile/tablet: slide-in/out using .show (you already have CSS for <=1199px)
      if (!this.sidebarMql.matches) { // < 1200px
        var isOpen = (typeof open === 'boolean') ? open : !this.sidebar.classList.contains('show');
        this.sidebar.classList.toggle('show', isOpen);
      } else {
        // Desktop: collapse/expand by toggling a class on the section container
        var isCollapsed = (typeof open === 'boolean')
          ? open     // true = collapse (hide sidebar), false = expand (show sidebar)
          : !container.classList.contains('sidebar-collapsed');

        container.classList.toggle('sidebar-collapsed', isCollapsed);
      }

      // Keep ARIA in sync for any toggle buttons inside this section
      container.querySelectorAll('.open_mobile_sidebar').forEach(function (b) {
        var expanded =
          !this.sidebarMql.matches
            ? this.sidebar.classList.contains('show')
            : !container.classList.contains('sidebar-collapsed'); // expanded when not collapsed
        b.classList.toggle('is-open', expanded);
        b.setAttribute('aria-expanded', String(expanded));
      }.bind(this));
    }.bind(this);

    // Set initial state of toggle buttons on page load
    if (this.sidebar && this.toggleBtns.length) {
      var isDesktop = this.sidebarMql.matches; // >= 1200px
      var isExpanded = isDesktop 
        ? !container.classList.contains('sidebar-collapsed') // Desktop: expanded if not collapsed
        : this.sidebar.classList.contains('show'); // Mobile: expanded if has .show class
      
      this.toggleBtns.forEach(function(btn) {
        btn.classList.toggle('is-open', isExpanded);
        btn.setAttribute('aria-expanded', String(isExpanded));
      });
    }



    var formsArr = container.querySelectorAll('[action="/cart/add"]');
    if(formsArr.length) {
      formsArr.forEach(function(form,index) {
        theme.AddItemToCart(form);

      });
    }
    theme.ProductItemSwatches();

    var sidebar_menu_items = container.querySelectorAll('.panel-heading.collapse');
    if(sidebar_menu_items.length) {
      sidebar_menu_items.forEach(function (item,index) {
        item.addEventListener('click',function (e) {
          e.preventDefault();

          
          var self = this;
          var panelId = item.getAttribute('data-collapse-panel');
          var itemPanel = document.querySelector('#'+panelId);

             for (let sibling of self.parentNode.children) {
        if (sibling !== self)  {
          if(sibling.classList.contains('active') && sibling.classList.contains('panel-heading') ) {
          sibling.dispatchEvent(new Event('click', { bubbles: true }));

          }
        }
          }
          
 

          if (!itemPanel.classList.contains('active')) {

            self.classList.add('active');
            itemPanel.classList.add('active');
            itemPanel.style.height = 'auto';
           var height = itemPanel.clientHeight + 'px';

            itemPanel.style.height = '0px';

            setTimeout(function () {
              itemPanel.style.height = height;
            }, 0);
                  setTimeout(function() {
                      itemPanel.style.height = 'auto';
          },300);

          } else {
   
        var height = itemPanel.clientHeight + 'px';

             itemPanel.style.height = height;
             setTimeout(function () {
              itemPanel.style.height = '0px';
            }, 0);
           

            itemPanel.addEventListener('transitionend', function () {
              itemPanel.classList.remove('active');
              self.classList.remove('active');
            }, {
              once: true
            });

          }

        });
      });
    }

    var filter_titles = container.querySelectorAll('.category-filters-section-title');
    if(filter_titles.length) {
      filter_titles.forEach(function(item,index) {



        var self = item;
        var parentArea = self.closest('.category-filters-area-section');
        var filtersBlock = parentArea.querySelector('.category-filters-area-list');

        if (filtersBlock.classList.contains('active')) {
          filtersBlock.style.height = 'auto';
          var height = filtersBlock.clientHeight + 'px';
          filtersBlock.style.height = height;
          setTimeout(function() {
                      filtersBlock.style.height = 'auto';
          },300);

        } else {
           filtersBlock.style.height = height;
           setTimeout(function() {
          filtersBlock.style.height = '0px';
           },300);
        }


        item.addEventListener('click', function(e) {
          e.preventDefault();

          var self = this;
          var parentArea = self.closest('.category-filters-area-section');
          var filtersBlock = parentArea.querySelector('.category-filters-area-list');
          
          if (!filtersBlock.classList.contains('active')) {

            self.classList.add('active');
            filtersBlock.classList.add('active');
            filtersBlock.style.height = 'auto';

            var height = filtersBlock.clientHeight + 'px';

            filtersBlock.style.height = '0px';

            setTimeout(function () {
              filtersBlock.style.height = height;
            }, 0);
             setTimeout(function() {
                      filtersBlock.style.height = 'auto';
          },300);

          } else {

              var height = filtersBlock.clientHeight + 'px';
             filtersBlock.style.height = height;
               setTimeout(function () {
              filtersBlock.style.height = '0px';
            }, 0);
            
            self.classList.remove('active');
            filtersBlock.classList.remove('active');

          }
        });
      });
    }

    var show_more_options = container.querySelectorAll('.show_more_options');
    if(show_more_options.length) {

      container.querySelectorAll('.advanced-filters').forEach(function(filter,index) {
        var children_length = filter.querySelectorAll('li').length;
        if(children_length > 5) {

          var heigth_limit = 0;
          for(var i=0; i < filter.querySelectorAll('li').length; i++) {
            var item = filter.querySelectorAll('li')[i];
            heigth_limit = heigth_limit + item.offsetHeight;
            if(i == 4) {
              break;
            }
          }

          var show_more_option = filter.nextElementSibling;
          if(show_more_option) {
            filter.setAttribute('data-heigth_limit', heigth_limit);
            filter.style.maxHeight = heigth_limit+'px';
            show_more_option.style.display = 'inline-block';
          }
        }
      });

      show_more_options.forEach(function (btn,index) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();

          var filters_list = this.previousElementSibling;
          var heigth_limit = filters_list.getAttribute('data-heigth_limit');
          var default_text = this.getAttribute('data-default-text');

          if(this.classList.contains("openedFilter")) {    
            filters_list.style.maxHeight  = heigth_limit+'px';
            this.classList.remove('openedFilter');
            this.innerHTML = default_text;
          } else {

            var filterBlockLength = 0;
            for(var i=0; i < filters_list.querySelectorAll('li').length; i++) {
              var item = filters_list.querySelectorAll('li')[i];
              filterBlockLength = filterBlockLength + item.offsetHeight;
            }
            filters_list.style.maxHeight = filterBlockLength+'px';
            this.classList.add('openedFilter');
            this.innerHTML = theme.strings.show_less;

          }
        });
      });
    };


    var change_layout_btns = container.querySelectorAll('[data-action="change-layout"]'); 
    if(change_layout_btns.length) {
      change_layout_btns.forEach(function(item,index) {
        item.addEventListener('click', function(e) {
          e.preventDefault();
          var this_btn = this;

          if (this_btn.classList.contains('is-selected')) {
            return;
          }

          var button_parent = this_btn.closest('.filters-toolbar');

          var newLayoutMode = this_btn.getAttribute('data-layout-mode');

          // We save the new attribute so that we can select the appropriate mode without causing reflow
          fetch(window.routes.cartUrl + '/update.js', {
            body: JSON.stringify({
              attributes: {
                'collection_layout': newLayoutMode
              }
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
          });

          button_parent.querySelector('.collection__layout-button.is-selected').classList.remove('is-selected');
          this_btn.classList.add('is-selected');
          var collectionWrappers = document.querySelectorAll('.Collection-wrapper');
          if(collectionWrappers.length) {
            collectionWrappers.forEach(function (collectionWrapper,index) {
              collectionWrapper.querySelectorAll('.product-item-block').forEach(function (productBlock,index) {

                if (newLayoutMode === 'grid') {
                  productBlock.classList.remove('view-mode-list');
                  productBlock.classList.add('view-mode-grid');
                } else {
                  productBlock.classList.add('view-mode-list');
                  productBlock.classList.remove('view-mode-grid');
                }
              });
            });
          }
        });
      });
    }


    var pagination_mode = container.getAttribute('data-pagination_mode');
    if(pagination_mode != 'standart') {
      var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: pagination_mode,
        offset: 500
      });
    }

    // Toggle buttons
if (this.toggleBtns.length) {
  this.toggleBtns.forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      this._setSidebarOpen(); // toggle
    }.bind(this));
  }.bind(this));
}

// Optional close button inside the sidebar
var close_sidebar_btn = container.querySelector('.close-collection-sidebar, [data-close-sidebar]');
if (close_sidebar_btn) {
  close_sidebar_btn.addEventListener('click', function(e){
    e.preventDefault();
    this._setSidebarOpen(false);
  }.bind(this));
}

// Close on ESC key
container.addEventListener('keydown', function(e){
  if (e.key === 'Escape' && this.sidebar && this.sidebar.classList.contains('show')) {
    this._setSidebarOpen(false);
  }
}.bind(this));

// Auto-close if switching to desktop (1200px+)
this.sidebarMql.addListener(function(mq){
  if (mq.matches && this.sidebar) this._setSidebarOpen(false);
}.bind(this));



var check_filter_value_btns = container.querySelectorAll('.advanced-filter a');
if(check_filter_value_btns.length) {
  check_filter_value_btns.forEach(function (item,index) {
    item.addEventListener('click',function (e) {
      e.preventDefault();
      var parentFilterNode = this.closest('.advanced-filter');
      var filterInput = parentFilterNode.querySelector('[type="checkbox"]');
      if(filterInput) {
        if(filterInput.checked) {
          filterInput.checked = false;
          parentFilterNode.classList.remove('active-filter');
        } else {
          filterInput.checked = true;
          parentFilterNode.classList.add('active-filter');
        }
      }

      // On mobile/tablet (under 1200px), don't auto-submit - wait for Apply button
      if (window.innerWidth < 1200) {
        return;
      }

      // On desktop (1200px+), submit immediately
      var FitersFormEl = item.closest('form');
      if(FitersFormEl) {
        const formData = new FormData(FitersFormEl);
        const searchParams = new URLSearchParams(formData).toString();
        var pathname = window.location.pathname;
        window.location.href = pathname + "?" + searchParams;
      } else {
        var href = this.getAttribute('href');
        var pathname = window.location.pathname;
        var search_url_size = window.location.search.length;
        if(search_url_size) {
          window.location.href = href + window.location.search;
        } else {
          window.location.href = href;
        }
      }
    });
  });
}

    var group__price_rangeBlocks = container.querySelectorAll('.filter-group-display__price-range-input');  
    if(group__price_rangeBlocks.length) {
      document.addEventListener('change', function(e){
        var el = e.target;

        if(el.classList.contains('filter-group-display__price-range-input')) {
          var FitersFormEl = el.closest('form');
          if(FitersFormEl) {
            const formData = new FormData(FitersFormEl);

            const searchParams = new URLSearchParams(formData).toString();
            var pathname  = window.location.pathname;
            window.location.href = pathname + "?" + searchParams;
          }	

        }
      });
    }
    var price_range_inputs =  container.querySelectorAll('.price_range'); 
    if(price_range_inputs.length) {
      document.addEventListener('change', function(e){
        var el = e.target;

        if(el.classList.contains('price_range')) {
          var FitersFormEl = el.closest('form');
          if(FitersFormEl) {

            var prices_arr = [];
            var price_range_inputs = FitersFormEl.querySelectorAll('.filter-group-display__price-range-input');
            var price_range_container = el.closest('.price_range_container');
            if(price_range_container) {
              price_range_container.querySelectorAll('.price_range').forEach(function(item,index) {
                var input_val = item.value * 1;
                prices_arr.push(input_val);
              });
              if(price_range_inputs.length) {
                var min = Math.min.apply(null, prices_arr),
                    max = Math.max.apply(null, prices_arr);
                price_range_inputs[0].value = min;
                price_range_inputs[1].value = max;
              }
            }

            const formData = new FormData(FitersFormEl);
            const searchParams = new URLSearchParams(formData).toString();
            var pathname  = window.location.pathname;
            window.location.href = pathname + "?" + searchParams;
          }	

        }
      });
    }

    var active_titles_arr =  container.querySelectorAll('.category-filters-section-title.active');

      if(active_titles_arr.length) { 
        if(window.innerWidth < 1200) {
          active_titles_arr.forEach(function (title,index) {
            title.dispatchEvent(new Event('click', { bubbles: true }));
          });
        }
      }
    
  }

  Collection.prototype = Object.assign({}, Collection.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {

      function clearLayoutSettings() {
        var headers = new Headers({ 'Content-Type': 'application/json' });
        var request = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ attributes: { 'collection_layout': '' } })
        };
        fetch('/cart/update.js', request)
        .then(function(response) {
        });
      }
      clearLayoutSettings();

      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChange);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChange);
      }

      this.mql.removeListener(this.initBreakpoints);



    }
  });

  return Collection;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();
  sections.register('collection-template', theme.Collection);
});

document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.custom-select-wrapper');
  if (!wrapper) return;
  
  const trigger = wrapper.querySelector('.custom-select-trigger');
  const select = wrapper.querySelector('.custom-select-hidden');
  const options = wrapper.querySelectorAll('.custom-select-option');
  
  // Toggle dropdown
  trigger.addEventListener('click', function() {
    wrapper.classList.toggle('is-open');
  });
  
  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!wrapper.contains(e.target)) {
      wrapper.classList.remove('is-open');
    }
  });
  
  // Handle option selection
  options.forEach(function(option) {
    option.addEventListener('click', function(e) {
      e.preventDefault();
      const value = this.dataset.value;
      
      // Update hidden select
      select.value = value;
      
      // Trigger change event
      select.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Update selected state
      options.forEach(opt => opt.classList.remove('is-selected'));
      this.classList.add('is-selected');
      
      // Close dropdown
      wrapper.classList.remove('is-open');
    });
  });
});

